/**
 * The fragment `/llms.txt` and `/llms-full.txt` put on every page link.
 *
 * Its own module because two very different files need it: `llms.ts`, which
 * imports every content bundle on the site to write those files, and the root
 * route, which runs on every page. Exported from `llms.ts`, the constant would
 * drag all of that prose into the root chunk. See `cite()` in `llms.ts` for why
 * a fragment rather than a query parameter.
 */
export const LLMS_FRAGMENT = "llms";

/**
 * Whether this visit arrived through a link that exists only in the llms files.
 *
 * The only first-party signal that an assistant found a page through them
 * rather than through the page itself: ChatGPT's `utm_source` says which
 * assistant, not which door.
 */
export function arrivedViaLlms(hash: string): boolean {
  return hash === `#${LLMS_FRAGMENT}`;
}
